/* eslint-disable sonarjs/no-duplicate-string */
export const thanksStepAnalytics = {
    view: {
        block: 'Страница спасибо',
        event: 'gtm_non_interaction_event',
        action: 'View',
        ymEvent: [
            {
                method: 'reachGoal',
                params: 'dc_thanks_page',
            },
        ],
        label_detail: 'Просмотр',
    },
    aoMobile: {
        block: 'Страница спасибо',
        event: 'gtm_interaction_event',
        action: 'Click',
        label_detail: 'Как добавить иконку',
    },
    aoDesktop: {
        block: 'Страница спасибо',
        event: 'gtm_interaction_event',
        action: 'Click',
        label_detail: 'В альфа онлайн',
    },
    mobileApp: {
        block: 'Страница спасибо',
        event: 'gtm_interaction_event',
        action: 'Click',
        label_detail: 'Как скачать приложение',
    },
    informerText: {
        block: 'Анкета Новая форма - Корзина',
        event: 'gtm_non_interaction_event',
        action: 'View',
        label_detail: 'Информер - напоминание сотруднику',
    },
    mobileSheet: {
        huaweiApp: {
            block: 'Страница спасибо',
            event: 'gtm_interaction_event',
            action: 'Click',
            label_detail: 'Скачать для Huawei',
        },
        aoMobileAddIcon: {
            block: 'Страница спасибо',
            event: 'gtm_interaction_event',
            action: 'Click',
            label_detail: 'Добавить иконку альфа онлайн',
        },
        androidXiaomiApp: {
            block: 'Страница спасибо',
            event: 'gtm_interaction_event',
            action: 'Click',
            label_detail: 'Скачать для Android и Xiaomi',
        },
    },
};
